import Axios from 'axios';

export const sorra_api = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_SORRA_API_HOST || 'http://localhost:3333',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export const swrSorraAPIFetcher = async (url) => {
  return sorra_api.get(url).then((res) => {
    if (res.data) {
      return res.data;
    }
    return [];
  });
};
